import script from "./customCaseItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./customCaseItem.vue?vue&type=script&setup=true&lang=ts"

import "./customCaseItem.vue?vue&type=style&index=0&id=2c849892&lang=less&scoped=true"

import exportComponent from "/opt/teams-app/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.74.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c849892"]])

export default __exports__